import React from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';

const { Paragraph, ActionButton } = designSystem;

const GalleryPagination = ({
  canLoadMore,
  captions,
  isLoading,
  onLoadMoreClick = Function.prototype,
}) => (
  <div className="ws-gallery-pagination">
    <Paragraph appearance="medium-emphasis" align="center">
      <span
        // eslint-disable-next-line yola/react/no-danger
        dangerouslySetInnerHTML={{ __html: captions.paginationLabel }}
      />
    </Paragraph>

    {canLoadMore && (
      <ActionButton
        label={captions.loadMoreButton}
        onClick={onLoadMoreClick}
        isLoading={isLoading}
      />
    )}
  </div>
);

GalleryPagination.propTypes = {
  captions: PropTypes.shape({
    paginationLabel: PropTypes.string,
    loadMoreButton: PropTypes.string,
  }).isRequired,
  canLoadMore: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onLoadMoreClick: PropTypes.func,
};

export default GalleryPagination;
